import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchDemandDataManpowerEstablishments extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { enterprise_id, position_id, target_industries_id, years } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">               
                        <Row className="mt-3">
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{enterprise_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={enterprise_id}
                                            option={{source: 'db', data: Masterbase?.enterprise}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                            disabled={!['0', '1', '5'].includes(UserCookie?.types)}
                                        />
                                </InputGroup>
                            </Col>
                            <Col md={4}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{position_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={position_id}
                                            option={{source: 'db', data: Masterbase?.position}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                        />
                                </InputGroup>
                            </Col>                    
                        </Row> 
                        <Row>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{target_industries_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={target_industries_id}
                                            option={{source: 'db', data: Masterbase?.target_industries}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                        />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{years.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={years}
                                            option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                        />
                                </InputGroup>
                            </Col>                    
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>                    
                        </Row> 
                    </Col>
                </Row>                               
            </>
        )
    }
}

export default SearchDemandDataManpowerEstablishments;